<template>
  <div class="action-button-group">
    <ActionButton
      v-for="(button, index) in buttons"
      :key="index"
      :text="button.text"
      :icon-src="button.iconSrc"
      :icon-clickable="button.iconClickable"
      :disabled="!!button.disabled"
      :disabled-reason="button.disabledReason"
      @click="handleButtonClick"
      @icon-click="handleIconClick(button.id)"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ActionButton from "@/components/atoms/ActionButton.vue";

export interface ActionButtonData {
  id?: string;
  text: string;
  iconSrc?: string;
  iconClickable?: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

export interface ActionButtonGroupProps {
  buttons: ActionButtonData[];
}

export default Vue.extend({
  name: "ActionButtonGroup",
  components: {
    ActionButton,
  },
  props: {
    buttons: {
      type: Array as () => ActionButtonData[],
      required: true,
    },
  },
  methods: {
    handleButtonClick(buttonText: string): void {
      this.$emit("button-click", buttonText);
    },
    handleIconClick(id?: string): void {
      this.$emit("icon-click", id);
    },
  },
});
</script>

<style lang="scss" scoped>
.action-button-group {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}
</style>
